<script lang="ts">
  import Link from "svelte-link";
  import { ContactCreated, ContactEmail, ContactHistory, Contactmodified, href,History } from "../../../utils/Constant/Constant";
  let open:boolean = false;
  const toggle = () => (open = !open);
</script>
<li>
  <Link href={href} on:click={toggle}>{History}</Link>
  <div class="history {open ? " show" : ""}" id="right-history">
    <div class="modal-header p-l-20 p-r-20">
      <h6 class="modal-title w-100">{ContactHistory}
        <span class="pull-right">
          <Link class="closehistory" href={href} on:click={toggle}>
            <i class="icofont icofont-close"></i>
          </Link>
        </span>
      </h6>
    </div>
    <div class="history-details">
      <div class="text-center">
        <i class="icofont icofont-ui-edit"></i>
        <p>{Contactmodified}</p>
      </div>
      <div class="media">
        <i class="icofont icofont-star me-3"></i>
        <div class="media-body mt-0">
          <h6 class="mt-0">{ContactCreated}</h6>
          <p class="mb-0">{ContactEmail}</p>
          <span class="f-12">{'Sep 10, 2019 4:00'}</span>
        </div>
      </div>
    </div>
  </div>
</li>